import PlatformActions from './PlatformActions'

export default class JDBSLOTActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameName: 'Super Niubi',
      gameCode: 'JDB-SLOT-070',
      platform: 'JDB',
    }

    this.constantGameInfo = {
      isEndRound: true,
      hasFreeGame: 0,
      denom: 0.2,
      systemTakeWin: 0,
    }
  }

  getBetNSettleMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotWinAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId, // 842856
      roundId, // 5250171846863
      betType: '',
      currency,
      betTime, // 2021-11-27T08:56:09.000+08:00
      txTime: betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotBetAmount: 0,
      jackpotWinAmount: jackpotWinAmount ?? 0,
      updateTime, // 2021-11-27T08:56:09.939+08:00
      requireAmount: betAmount,
      gameInfo: this.constantGameInfo,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'betNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetNSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId,
      roundId,
      updateTime,
      betAmount,
      gameInfo: this.constantGameInfo,
    }))

    const message = {
      action: 'cancelBetNSettle',
      txns,
    }

    return JSON.stringify(message)
  }
}
